import Separator from '@cobliteam/colib-ui/Separator';
import { Link } from 'react-router-dom';
import logo from '../../../assets/images/logo.svg';

const LogoComponent = () => {
  return (
    <>
      <Link to='/' className='shrink-0'>
        <img src={logo} alt='Cobli' className='size-6 shrink-0 dark:brightness-0 dark:invert' />
      </Link>
      <Separator orientation='vertical' className='mx-1 h-8' />
    </>
  );
};

export default LogoComponent;
